module.exports = __webpack_public_path__ + "img/グループ 258.5c153cd5.png";